export const acceptJsonWithoutCache = {
  Accept: "application/json",
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
};
